export default __webpack_public_path__ + "static/media/returnrepair1.69a888d4.jpeg";